import { styled } from '@linaria/react';
import { primitives, semantic, size, space } from '../../theme/tokens';

export const ToggleWrapper = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-200']};
  padding: ${space['space-100']};
  border-radius: ${size.radius['radius-full']};
  background: ${semantic.bg.surfaceSubtle};
`;

export const ToggleButton = styled.button<{ $active: boolean }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${space['space-100']};
  height: ${primitives.size['size-1000']};
  padding: ${space['space-100']} ${space['space-400']};
  border: none;
  border-radius: ${size.radius['radius-full']};
  background: ${({ $active }) => ($active ? semantic.bg.secondary : 'transparent')};
  color: ${semantic.icon.primary};
  box-sizing: border-box;
  cursor: pointer;
  transition: background 0.15s ease;

  &:focus-visible {
    outline: ${size.stroke['stroke-thick']} solid ${semantic.border.selected};
    outline-offset: ${space['space-050']};
  }
`;
